<ion-header>
  <ion-toolbar>
    <ion-title>
      Noticia
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="overflow-auto"> 
  <div *ngIf="singleNew" style="margin: 10%;">
    <ion-card class="horizontalCenter">
      <ion-img [src]="singleNew.image"></ion-img>
    </ion-card> 
    <div>
      <h5> {{singleNew.created | date:'yyyy/MM/dd'}} </h5>
      <h2>{{singleNew.title}}</h2>

      <p class="description">
        {{singleNew.description}}
      </p>

      <p [innerHTML]="singleNew.content | keepHtml:'html'"></p>
    </div>
  </div>
</ion-content>
